<template>
   <b-modal
    ref="modal"
    header-bg-variant="warning"
    header-text-variant="dark"
    no-close-on-backdrop
    size="xl"
    @hide="onModalHide"
    @shown="onModalShown"
    @hidden="onModalFullyHidden"
    > <!-- Custom header --> <template #modal-header
      >
      <div class="d-flex align-items-center justify-content-between w-100">

        <div class="d-flex align-items-center">
           <i class="fas fa-pen text-dark mr-2"></i>
          <h5 class="modal-title mb-0">Chỉnh sửa hoá đơn</h5>

        </div>
         <small
          class="text-dark"
          style="opacity: 0.6"
          > <kbd>Ctrl+S</kbd> lưu &nbsp; <span v-if="canIssueCurrentInvoice"
            ><kbd>Ctrl+Shift+S</kbd> lưu & phát hành</span
          > </small
        >
      </div>
       </template
    > <!-- Custom footer --> <template #modal-footer="{ cancel }"
      >
      <div class="d-flex w-100 justify-content-between align-items-center">
         <!-- Left: Reset --> <b-button
          v-if="isDirty"
          variant="outline-secondary"
          size="sm"
          :disabled="isHydrating || isSubmitting || isIssuing"
          @click="resetForm"
          > <i class="fas fa-undo mr-1"></i>Đặt lại </b-button
        >
        <div v-else></div>
         <!-- Right: Close / Save / Save & Issue -->
        <div class="d-flex align-items-center">
           <b-button
            variant="secondary"
            size="sm"
            class="mr-2"
            :disabled="isHydrating || isSubmitting || isIssuing"
            @click="cancel()"
            > Đóng </b-button
          > <b-button
            v-if="canIssueCurrentInvoice"
            variant="success"
            size="sm"
            class="mr-2 font-weight-bolder"
            :disabled="isHydrating || isSubmitting || isIssuing"
            @click="handleSaveAndIssue"
            > <b-spinner
              v-if="isIssuing"
              small
              class="mr-1"
            ></b-spinner
            > <i
              v-else
              class="fas fa-paper-plane mr-1"
            ></i
            > Lưu &amp; Phát hành </b-button
          > <b-button
            variant="warning"
            size="sm"
            class="font-weight-bolder"
            :disabled="isHydrating || isSubmitting || isIssuing"
            @click="handleSubmit"
            > <b-spinner
              v-if="isSubmitting"
              small
              class="mr-1"
            ></b-spinner
            > <i
              v-else
              class="fas fa-save mr-1"
            ></i
            > Lưu thay đổi </b-button
          >
        </div>

      </div>
       </template
    > <template v-if="invoice"
      > <!-- Sticky summary header -->
      <div class="einvoice-edit-sticky-header mb-3">

        <div class="d-flex align-items-center justify-content-between">

          <div class="d-flex align-items-center flex-wrap">
             <EInvoiceStatusBadge
              :status="invoice.status"
              size="sm"
              class="mr-2"
            /> <span class="font-weight-bold mr-2">{{ invoice.invoiceNo || 'Nháp' }}</span
            > <span
              class="text-muted"
              style="font-size: 0.82rem"
              > {{ invoice.pattern }}/{{ invoice.serial }} </span
            > <span
              v-if="invoice.saleInvoiceCode"
              class="text-muted ml-3"
              style="font-size: 0.82rem"
              > <i class="fas fa-receipt mr-1"></i>{{ invoice.saleInvoiceCode }} </span
            >
          </div>

          <div class="text-right">
             <span
              class="text-muted mr-1"
              style="font-size: 0.82rem"
              >Tổng:</span
            > <span
              class="font-weight-bold text-primary"
              style="font-size: 1rem"
              > {{ formatCurrency(computedTotalAmount) }} </span
            >
          </div>

        </div>

        <div
          v-if="isDirty"
          class="mt-1"
        >
           <small class="text-warning"
            > <i class="fas fa-exclamation-circle mr-1"></i>Có thay đổi chưa lưu </small
          >
        </div>

      </div>
       <!-- Card 1: Buyer info (collapsible) -->
      <div class="einvoice-edit-card mb-2">

        <div
          v-b-toggle="'card-buyer'"
          class="einvoice-edit-card-header"
          role="button"
        >

          <div class="d-flex align-items-center">
             <i class="fas fa-user mr-2 text-primary"></i> <span class="font-weight-bold"
              >Thông tin người mua</span
            > <b-badge
              v-if="buyerSectionDirty"
              variant="warning"
              class="ml-2"
              style="font-size: 0.65rem"
              >đã sửa</b-badge
            >
          </div>
           <i class="fas fa-chevron-down einvoice-collapse-icon"></i>
        </div>
         <b-collapse
          id="card-buyer"
          visible
          >
          <div class="einvoice-edit-card-body">
             <b-row
              > <b-col md="6"
                > <b-form-group
                  label-class="font-weight-bold"
                  :invalid-feedback="getFieldError('buyerName')"
                  :state="getFieldState('buyerName')"
                  > <template #label
                    > Tên người mua * <i
                      class="fas fa-question-circle text-muted ml-1"
                      v-b-tooltip.hover
                      title="Họ tên hoặc tên công ty của người mua"
                    ></i
                    > </template
                  > <b-form-input
                    ref="buyerNameInput"
                    v-model="form.buyerName"
                    size="sm"
                    placeholder="Nhập tên người mua"
                    :state="getFieldState('buyerName')"
                    :class="{ 'field-dirty': isFieldDirty('buyerName') }"
                    :title="
                      isFieldDirty('buyerName')
                        ? `Giá trị gốc: ${getOriginalFieldValue('buyerName')}`
                        : undefined
                    "
                    v-b-tooltip.hover
                    @input="$v.form.buyerName.$touch()"
                    @blur="$v.form.buyerName.$touch()"
                  ></b-form-input
                  > </b-form-group
                > </b-col
              > <b-col md="6"
                > <b-form-group label-class="font-weight-bold"
                  > <template #label
                    > Mã số thuế <i
                      class="fas fa-question-circle text-muted ml-1"
                      v-b-tooltip.hover
                      title="10 chữ số (VD: 0123456789) hoặc 13 chữ số với gạch ngang (VD: 0123456789-001)"
                    ></i
                    > </template
                  > <b-form-input
                    v-model="form.buyerTaxCode"
                    size="sm"
                    placeholder="Mã số thuế (nếu có)"
                    :class="{ 'field-dirty': isFieldDirty('buyerTaxCode') }"
                    :title="
                      isFieldDirty('buyerTaxCode')
                        ? `Giá trị gốc: ${getOriginalFieldValue('buyerTaxCode')}`
                        : undefined
                    "
                    v-b-tooltip.hover
                  ></b-form-input
                  > </b-form-group
                > </b-col
              > <b-col md="6"
                > <b-form-group
                  label-class="font-weight-bold"
                  :invalid-feedback="getFieldError('buyerEmail')"
                  :state="getFieldState('buyerEmail')"
                  > <template #label
                    > Email <i
                      class="fas fa-question-circle text-muted ml-1"
                      v-b-tooltip.hover
                      title="Hoá đơn điện tử sẽ được gửi đến địa chỉ email này"
                    ></i
                    > </template
                  > <b-form-input
                    v-model="form.buyerEmail"
                    size="sm"
                    type="email"
                    placeholder="Email nhận hoá đơn"
                    :state="getFieldState('buyerEmail')"
                    :class="{ 'field-dirty': isFieldDirty('buyerEmail') }"
                    :title="
                      isFieldDirty('buyerEmail')
                        ? `Giá trị gốc: ${getOriginalFieldValue('buyerEmail')}`
                        : undefined
                    "
                    v-b-tooltip.hover
                    @input="$v.form.buyerEmail.$touch()"
                    @blur="$v.form.buyerEmail.$touch()"
                  ></b-form-input
                  > </b-form-group
                > </b-col
              > <b-col md="6"
                > <b-form-group
                  label="Địa chỉ"
                  label-class="font-weight-bold"
                  > <b-form-input
                    v-model="form.buyerAddress"
                    size="sm"
                    placeholder="Địa chỉ người mua"
                    :class="{ 'field-dirty': isFieldDirty('buyerAddress') }"
                    :title="
                      isFieldDirty('buyerAddress')
                        ? `Giá trị gốc: ${getOriginalFieldValue('buyerAddress')}`
                        : undefined
                    "
                    v-b-tooltip.hover
                  ></b-form-input
                  > </b-form-group
                > </b-col
              > <b-col
                v-if="isPortalDraft"
                md="6"
                > <b-form-group
                  label-class="font-weight-bold"
                  > <template #label
                    > Người mua hàng <i
                      class="fas fa-question-circle text-muted ml-1"
                      v-b-tooltip.hover
                      title="Tên người mua hàng"
                    ></i
                    > </template
                  > <b-form-input
                    v-model="form.contactPersonName"
                    size="sm"
                    placeholder="Tên người mua hàng"
                    :class="{ 'field-dirty': isFieldDirty('contactPersonName') }"
                    :title="
                      isFieldDirty('contactPersonName')
                        ? `Giá trị gốc: ${getOriginalFieldValue('contactPersonName')}`
                        : undefined
                    "
                    v-b-tooltip.hover
                  ></b-form-input
                  > </b-form-group
                > </b-col
              > </b-row
            >
          </div>
           </b-collapse
        >
      </div>
       <!-- Card 2: Invoice date (collapsible) -->
      <div class="einvoice-edit-card mb-2">

        <div
          v-b-toggle="'card-date'"
          class="einvoice-edit-card-header"
          role="button"
        >

          <div class="d-flex align-items-center">
             <i class="fas fa-calendar-alt mr-2 text-primary"></i> <span class="font-weight-bold"
              >Ngày hoá đơn</span
            > <b-badge
              v-if="isFieldDirty('invoiceDate')"
              variant="warning"
              class="ml-2"
              style="font-size: 0.65rem"
              >đã sửa</b-badge
            >
          </div>
           <i class="fas fa-chevron-down einvoice-collapse-icon"></i>
        </div>
         <b-collapse
          id="card-date"
          visible
          >
          <div class="einvoice-edit-card-body">
             <b-row
              > <b-col md="4"
                > <b-form-group
                  label-class="font-weight-bold"
                  :invalid-feedback="getFieldError('invoiceDate')"
                  :state="getFieldState('invoiceDate')"
                  > <template #label
                    > Ngày hoá đơn * <i
                      class="fas fa-question-circle text-muted ml-1"
                      v-b-tooltip.hover
                      title="Ngày ký phát hoá đơn. Không thể thay đổi sau khi phát hành"
                    ></i
                    > </template
                  > <date-picker
                    v-model="form.invoiceDate"
                    format="dd/MM/yyyy"
                    input-class="form-control form-control-sm"
                    :bootstrap-styling="true"
                    placeholder="Chọn ngày"
                    @input="$v.form.invoiceDate.$touch()"
                    @closed="$v.form.invoiceDate.$touch()"
                  ></date-picker
                  > <b-form-invalid-feedback :state="getFieldState('invoiceDate')"
                    > {{ getFieldError('invoiceDate') }} </b-form-invalid-feedback
                  > </b-form-group
                > </b-col
              > </b-row
            >
          </div>
           </b-collapse
        >
      </div>
       <!-- Card 3: Line items + totals (collapsible) -->
      <div class="einvoice-edit-card mb-2">

        <div
          v-b-toggle="'card-lines'"
          class="einvoice-edit-card-header"
          role="button"
        >

          <div class="d-flex align-items-center">
             <i class="fas fa-list mr-2 text-primary"></i> <span class="font-weight-bold"
              > Chi tiết hàng hoá/dịch vụ <b-badge
                variant="secondary"
                class="ml-1"
                style="font-size: 0.65rem"
                > {{ form.lineItems.length }} dòng </b-badge
              > </span
            >
          </div>
           <!-- Stop propagation so clicking "Thêm dòng" doesn't toggle collapse -->
          <div
            class="d-flex align-items-center"
            @click.stop
          >
             <b-button
              variant="outline-primary"
              size="sm"
              class="mr-2"
              @click="addLineItem"
              > <i class="fas fa-plus mr-1"></i>Thêm dòng </b-button
            > <i class="fas fa-chevron-down einvoice-collapse-icon"></i>
          </div>

        </div>
         <b-collapse
          id="card-lines"
          visible
          >
          <div class="p-0">

            <div class="einvoice-edit-lines">
               <b-table
                bordered
                :items="form.lineItems"
                :fields="lineItemFields"
                show-empty
                empty-text="Chưa có hàng hoá"
                class="mb-0"
                tbody-tr-class="einvoice-line-row"
                > <template #cell(index)="{ index }">{{ index + 1 }}</template
                > <template #cell(productName)="{ item, index }"
                  >
                  <div class="einvoice-edit-line-product">
                     <ProductImage :src="item.imageUrl" />
                    <div class="einvoice-edit-line-product__input">
                       <b-form-input
                        :ref="`line_${index}_name`"
                        v-model="item.productName"
                        size="sm"
                        placeholder="Tên hàng hoá"
                        :state="getLineFieldState(index, 'productName')"
                        @input="touchLineField(index, 'productName')"
                        @blur="touchLineField(index, 'productName')"
                        @keydown.enter.prevent="focusLineField(index, 'quantity')"
                      ></b-form-input
                      >
                      <div
                        v-if="item.itemCode || item.productCode"
                        class="einvoice-edit-line-product__code"
                        :title="item.itemCode || item.productCode"
                      >
                         {{ item.itemCode || item.productCode }}
                      </div>

                    </div>

                  </div>
                   </template
                > <template #cell(unit)="{ item }"
                  > <b-form-input
                    v-model="item.unit"
                    size="sm"
                    placeholder="ĐVT"
                  ></b-form-input
                  > </template
                > <template #cell(quantity)="{ item, index }"
                  > <b-form-input
                    :ref="`line_${index}_quantity`"
                    v-model.number="item.quantity"
                    size="sm"
                    type="number"
                    min="1"
                    :state="getLineFieldState(index, 'quantity')"
                    @input="touchLineField(index, 'quantity')"
                    @blur="touchLineField(index, 'quantity')"
                    @keydown.enter.prevent="focusLineField(index, 'unitPrice')"
                  ></b-form-input
                  > </template
                > <template #cell(unitPrice)="{ item, index }"
                  > <b-form-input
                    :ref="`line_${index}_unitPrice`"
                    v-model.number="item.unitPrice"
                    size="sm"
                    type="number"
                    min="0"
                    :state="getLineFieldState(index, 'unitPrice')"
                    @input="touchLineField(index, 'unitPrice')"
                    @blur="touchLineField(index, 'unitPrice')"
                    @keydown.enter.prevent="onLineItemEnterLast(index)"
                  ></b-form-input
                  > </template
                > <template #cell(taxRate)="{ item }"
                  > <b-form-select
                    v-model="item.taxRate"
                    size="sm"
                    :options="taxRateOptions"
                  ></b-form-select
                  > </template
                > <template #cell(amount)="{ index }"
                  > <strong>{{ formatCurrency(computeLineAmount(index)) }}</strong
                  > </template
                > <template #cell(action)="{ index }"
                  > <b-button
                    v-if="form.lineItems.length > 1"
                    variant="outline-danger"
                    size="sm"
                    @click="removeLineItem(index)"
                    > <i class="fas fa-trash-alt"></i> </b-button
                  > </template
                > </b-table
              >
            </div>
             <!-- Totals inline below line-item table -->
            <div class="einvoice-edit-totals">

              <table class="table table-sm table-borderless mb-0">

                <tr>

                  <td class="text-right text-muted">Cộng tiền hàng:</td>

                  <td
                    class="text-right font-weight-bold"
                    style="width: 155px"
                  >
                     {{ formatCurrency(computedTotalBeforeTax) }}
                  </td>

                </tr>

                <tr>

                  <td class="text-right text-muted">Thuế GTGT:</td>

                  <td class="text-right font-weight-bold">
                     {{ formatCurrency(computedVatAmount) }}
                  </td>

                </tr>

                <tr class="border-top">

                  <td class="text-right text-muted font-weight-bold">Tổng thanh toán:</td>

                  <td class="text-right font-weight-bold text-primary font-size-lg">
                     {{ formatCurrency(computedTotalAmount) }}
                  </td>

                </tr>

              </table>

            </div>

          </div>
           </b-collapse
        >
      </div>
       </template
    > <!-- Loading overlay --> <loading-overlay
      :active="isHydrating || isSubmitting || isIssuing"
      :is-full-page="false"
      > <template #default
        >
        <div class="text-center">
           <b-spinner variant="warning"></b-spinner>
          <p class="mt-2 text-muted">{{ loadingText }}</p>

        </div>
         </template
      > </loading-overlay
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength, email, minValue } from 'vuelidate/lib/validators'
  import DatePicker from 'vuejs-datepicker'
  import LoadingOverlay from '@/view/components/common/LoadingOverlay.vue'
  import {
    EINVOICE_UPDATE_DRAFT,
    EINVOICE_FETCH_DETAIL,
    EINVOICE_FETCH_FACET,
  } from '@/core/services/store/modules/einvoice/einvoice.module'
  import { FAST_TAX_RATES } from '@/utils/einvoice.enum'
  import {
    buildEditDraftPayload,
    computeDraftTotals,
    computeLineGrossAmount,
    computeLineNetAmount,
    computeLineTaxAmount,
    normalizeEditLineItem,
    runSaveAndIssueFlow,
  } from '@/view/pages/einvoice/utils/editDraft.utils'
  import { buildDraftEditorSeed } from '@/view/pages/einvoice/utils/einvoiceViewModel.selectors'
  import { getToastInstance } from '@/utils/toastHelper'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import einvoiceMixin from '../mixins/einvoice.mixin'
  import EInvoiceStatusBadge from './EInvoiceStatusBadge.vue'

  const { makeToastSuccess, makeToastFailure } = getToastInstance()

  const createEmptyLine = () => ({
    lineNumber: null,
    processType: 1,
    productCode: '',
    itemCode: '',
    productName: '',
    itemName: '',
    unit: '',
    unitOfMeasure: '',
    quantity: 1,
    unitPrice: 0,
    discountRate: 0,
    discountAmount: 0,
    taxRate: 10,
    taxAmount: 0,
    isBonus: false,
    billItemId: null,
    productId: null,
    imageUrl: null,
  })

  const deepCloneForm = (form) =>
    JSON.parse(
      JSON.stringify({
        ...form,
        invoiceDate: form.invoiceDate ? form.invoiceDate.toISOString() : null,
      }),
    )

  export default {
    name: 'EInvoiceEditModal',
    components: { DatePicker, LoadingOverlay, ProductImage, EInvoiceStatusBadge },
    mixins: [validationMixin, einvoiceMixin],
    props: {
      invoice: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isHydrating: false,
        isSubmitting: false,
        isIssuing: false,
        loadingText: 'Đang lưu thay đổi...',
        originalFormSnapshot: null,
        form: {
          buyerName: '',
          contactPersonName: '',
          buyerTaxCode: '',
          buyerEmail: '',
          buyerAddress: '',
          invoiceDate: null,
          lineItems: [createEmptyLine()],
        },
      }
    },
    validations: {
      form: {
        buyerName: { required, minLength: minLength(1) },
        buyerEmail: { email },
        invoiceDate: { required },
        lineItems: {
          $each: {
            productName: { required },
            quantity: { required, minValue: minValue(1) },
            unitPrice: { required, minValue: minValue(0) },
          },
        },
      },
    },
    computed: {
      lineItemFields() {
        return [
          {
            key: 'index',
            label: 'STT',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: { width: '45px' },
          },
          { key: 'productName', label: 'Tên hàng hoá/dịch vụ *', thStyle: { minWidth: '240px' } },
          { key: 'unit', label: 'ĐVT', thClass: 'text-center', thStyle: { width: '80px' } },
          { key: 'quantity', label: 'SL *', thClass: 'text-center', thStyle: { width: '80px' } },
          {
            key: 'unitPrice',
            label: 'Đơn giá *',
            thClass: 'text-right',
            thStyle: { width: '130px' },
          },
          {
            key: 'taxRate',
            label: 'Thuế suất',
            thClass: 'text-center',
            thStyle: { width: '150px' },
          },
          {
            key: 'amount',
            label: 'Thành tiền',
            thClass: 'text-right',
            tdClass: 'text-right',
            thStyle: { width: '130px' },
          },
          { key: 'action', label: '', thStyle: { width: '50px' }, tdClass: 'text-center' },
        ]
      },
      taxRateOptions() {
        return FAST_TAX_RATES.map((rate) => {
          if (rate === -1) return { value: -1, text: 'KCT — Không chịu thuế' }
          if (rate === -2) return { value: -2, text: 'KKK — Không kê khai' }
          if (rate === -9) return { value: -9, text: 'XK — Xuất khẩu 0%' }
          return { value: rate, text: `${rate}%` }
        })
      },
      computedTotalBeforeTax() {
        return computeDraftTotals(this.form.lineItems).totalBeforeTax
      },
      computedVatAmount() {
        return computeDraftTotals(this.form.lineItems).vatAmount
      },
      computedTotalAmount() {
        return computeDraftTotals(this.form.lineItems).totalAmount
      },
      isDirty() {
        if (!this.originalFormSnapshot) return false
        const current = deepCloneForm(this.form)
        return JSON.stringify(current) !== JSON.stringify(this.originalFormSnapshot)
      },
      buyerSectionDirty() {
        return ['buyerName', 'contactPersonName', 'buyerTaxCode', 'buyerEmail', 'buyerAddress'].some(
          (f) => this.isFieldDirty(f),
        )
      },
      canIssueCurrentInvoice() {
        if (!this.invoice) return false
        return this.canIssueInvoiceByContext(this.invoice)
      },
      // Chỉ luồng portal (bán buôn) mới có "Người mua hàng" truyền sang FAST Buyer
      isPortalDraft() {
        const saleType = String(this.invoice?.saleType || '').toUpperCase()
        return saleType.includes('WHOLESALE') || saleType.includes('PORTAL')
      },
    },
    methods: {
      // ── Public API ────────────────────────────────────────────
      async show() {
        this.$refs.modal.show()
        await this.hydrateForm()
      },
      hide() {
        this.$refs.modal.hide()
      },

      // ── Lifecycle hooks for keyboard shortcuts ────────────────
      onModalShown() {
        window.addEventListener('keydown', this.handleGlobalKeydown)
      },
      onModalFullyHidden() {
        window.removeEventListener('keydown', this.handleGlobalKeydown)
      },

      // ── Form init ─────────────────────────────────────────────
      async hydrateForm() {
        if (!this.invoice) return

        const hasCanonicalLineItems =
          Array.isArray(this.invoice.lineItems) && this.invoice.lineItems.length > 0

        if (hasCanonicalLineItems) {
          this.populateForm(this.invoice)
          return
        }

        if (!this.invoice?.salesInvoiceId || !this.invoice?.saleType) {
          this.populateForm(this.invoice)
          return
        }

        this.isHydrating = true
        this.loadingText = 'Đang tải dữ liệu canonical...'

        try {
          const detail = await this.$store.dispatch(EINVOICE_FETCH_DETAIL, {
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
          })
          this.populateForm(buildDraftEditorSeed(detail || {}))
        } catch (err) {
          this.populateForm(this.invoice)
          makeToastFailure(err?.message || 'Không thể tải dữ liệu nháp canonical')
        } finally {
          this.isHydrating = false
          this.loadingText = 'Đang lưu thay đổi...'
        }
      },
      populateForm(seed = this.invoice) {
        if (!seed) return
        const inv = seed
        this.form = {
          buyerName: inv.buyerName || '',
          contactPersonName: inv.contactPersonName || '',
          buyerTaxCode: inv.buyerTaxCode || '',
          buyerEmail: inv.buyerEmail || '',
          buyerAddress: inv.buyerAddress || '',
          invoiceDate: inv.invoiceDate ? new Date(inv.invoiceDate) : null,
          lineItems:
            inv.lineItems && inv.lineItems.length
              ? inv.lineItems.map((li, index) => normalizeEditLineItem(li, index))
              : [createEmptyLine()],
        }
        this.$v.$reset()
        this.$nextTick(() => {
          this.originalFormSnapshot = deepCloneForm(this.form)
        })
      },
      resetForm() {
        if (!this.originalFormSnapshot) return
        const snap = this.originalFormSnapshot
        this.form = {
          buyerName: snap.buyerName,
          contactPersonName: snap.contactPersonName,
          buyerTaxCode: snap.buyerTaxCode,
          buyerEmail: snap.buyerEmail,
          buyerAddress: snap.buyerAddress,
          invoiceDate: snap.invoiceDate ? new Date(snap.invoiceDate) : null,
          lineItems: JSON.parse(JSON.stringify(snap.lineItems)),
        }
        this.$v.$reset()
      },

      // ── Line item CRUD ────────────────────────────────────────
      addLineItem() {
        this.form.lineItems.push(createEmptyLine())
        this.$nextTick(() => {
          const newIndex = this.form.lineItems.length - 1
          this.focusLineField(newIndex, 'name')
        })
      },
      removeLineItem(index) {
        if (this.form.lineItems.length > 1) {
          this.form.lineItems.splice(index, 1)
        }
      },
      computeLineGrossAmount(index) {
        const line = this.form.lineItems[index]
        return computeLineGrossAmount(line)
      },
      computeLineNetAmount(index) {
        const line = this.form.lineItems[index]
        return computeLineNetAmount(line)
      },
      computeLineTaxAmount(index) {
        const line = this.form.lineItems[index]
        return computeLineTaxAmount(line)
      },
      computeLineAmount(index) {
        return this.computeLineGrossAmount(index)
      },

      // ── Line-item keyboard navigation (Phase 3.1) ─────────────
      focusLineField(rowIndex, fieldKey) {
        this.$nextTick(() => {
          const ref = this.$refs[`line_${rowIndex}_${fieldKey}`]
          if (!ref) return
          const el = ref.$el || ref
          if (el && typeof el.focus === 'function') el.focus()
        })
      },
      onLineItemEnterLast(rowIndex) {
        const isLastRow = rowIndex === this.form.lineItems.length - 1
        if (isLastRow) {
          this.addLineItem()
        } else {
          this.focusLineField(rowIndex + 1, 'name')
        }
      },

      // ── Keyboard shortcuts (Phase 3.4) ────────────────────────
      handleGlobalKeydown(e) {
        if (e.ctrlKey && e.shiftKey && e.key === 'S') {
          e.preventDefault()
          if (this.canIssueCurrentInvoice && !this.isSubmitting && !this.isIssuing) {
            this.handleSaveAndIssue()
          }
          return
        }
        if (e.ctrlKey && (e.key === 's' || e.key === 'S')) {
          e.preventDefault()
          if (!this.isSubmitting && !this.isIssuing) {
            this.handleSubmit()
          }
        }
      },

      // ── Dirty / diff helpers ──────────────────────────────────
      isFieldDirty(field) {
        if (!this.originalFormSnapshot) return false
        const current = this.form[field]
        const original = this.originalFormSnapshot[field]
        if (current instanceof Date) {
          return current.toISOString() !== original
        }
        return String(current || '') !== String(original || '')
      },
      getOriginalFieldValue(field) {
        if (!this.originalFormSnapshot) return ''
        const val = this.originalFormSnapshot[field]
        return val || '(trống)'
      },

      // ── Validation helpers ────────────────────────────────────
      getFieldState(field) {
        const v = this.$v.form[field]
        if (!v) return null
        return v.$dirty ? !v.$error : null
      },
      getFieldError(field) {
        const v = this.$v.form[field]
        if (!v) return ''
        if (field === 'buyerName' && !v.required) return 'Vui lòng nhập tên người mua'
        if (field === 'buyerEmail' && v.$dirty && !v.email) return 'Email không hợp lệ'
        if (field === 'invoiceDate' && !v.required) return 'Vui lòng chọn ngày hoá đơn'
        return ''
      },
      getLineFieldState(index, field) {
        const lineV = this.$v.form.lineItems.$each[index]
        if (!lineV || !lineV[field]) return null
        return lineV[field].$dirty ? !lineV[field].$error : null
      },
      touchLineField(index, field) {
        const lineV = this.$v.form.lineItems.$each[index]
        if (lineV && lineV[field]) lineV[field].$touch()
      },
      scrollToFirstError() {
        this.$nextTick(() => {
          const modal = this.$refs.modal?.$refs?.body
          if (!modal) return
          const firstInvalid = modal.querySelector('.is-invalid, .invalid-feedback.d-block')
          if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
            const input = firstInvalid.matches('input, select, textarea')
              ? firstInvalid
              : firstInvalid.querySelector('input, select, textarea')
            if (input) input.focus()
          }
        })
      },

      // ── Enhanced error handling (Phase 2.7) ──────────────────
      getErrorMessage(err) {
        const stagePrefixByKey = {
          save: 'Lưu nháp thất bại',
          preview: 'Tạo preview kiểm tra thất bại',
          validate: 'Kiểm tra điều kiện phát hành thất bại',
          issue: 'Phát hành hoá đơn thất bại',
        }
        const withStagePrefix = (message) => {
          const prefix = stagePrefixByKey[err?.flowStage]
          return prefix ? `${prefix}: ${message}` : message
        }
        if (err?.code === 'DRAFT_ITEMS_EMPTY') {
          return withStagePrefix(
            'Bản nháp chưa có line-items đã lưu. Vui lòng Re-bootstrap draft rồi issue lại.',
          )
        }
        if (
          err?.code === 'DRAFT_RECORD_NOT_FOUND' ||
          err?.isStaleDraft ||
          (err?.response?.status === 404 && err?.flowStage === 'validate')
        ) {
          return withStagePrefix(
            'Draft đã stale hoặc không còn tồn tại. Hệ thống đã tải lại trạng thái mới nhất, vui lòng Re-bootstrap draft rồi phát hành lại.',
          )
        }
        const validationErrors = err?.validationResult?.errors
        if (validationErrors && validationErrors.length) {
          return withStagePrefix(validationErrors.map((item) => item.message || item).join('; '))
        }

        const code = err?.response?.status
        if (code === 409) {
          return withStagePrefix(
            'Hoá đơn đang được chỉnh sửa bởi người khác. Vui lòng thử lại sau.',
          )
        }
        if (code === 410) {
          return withStagePrefix('Trạng thái hoá đơn đã thay đổi. Vui lòng đóng và tải lại trang.')
        }
        if (code === 400) {
          const errors = err?.response?.data?.errors
          if (errors && errors.length) {
            return withStagePrefix(errors.map((item) => item.message || item).join('; '))
          }
          return withStagePrefix(
            err?.message ||
              err?.response?.data?.message ||
              'Tổng tiền không khớp với line items. Vui lòng kiểm tra lại.',
          )
        }
        if (code === 422) {
          const errors = err?.response?.data?.errors
          if (errors && errors.length) {
            return withStagePrefix(errors.map((e) => e.message || e).join('; '))
          }
        }
        return withStagePrefix(
          err?.message || err?.response?.data?.message || 'Thao tác thất bại. Vui lòng thử lại.',
        )
      },
      async handleStaleDraftRecovery() {
        if (!this.invoice?.salesInvoiceId || !this.invoice?.saleType) {
          return
        }

        try {
          await Promise.all([
            this.$store.dispatch(EINVOICE_FETCH_FACET, {
              salesInvoiceId: this.invoice.salesInvoiceId,
              saleType: this.invoice.saleType,
              force: true,
            }),
            this.$store.dispatch(EINVOICE_FETCH_DETAIL, {
              salesInvoiceId: this.invoice.salesInvoiceId,
              saleType: this.invoice.saleType,
              force: true,
            }),
          ])
        } catch (_) {
          // Keep user-facing stale-draft error as source of truth.
        }
      },
      applyIssueStage(stage) {
        const labelByStage = {
          save: 'Đang lưu nháp trước khi phát hành...',
          preview: 'Đang dựng preview để đối chiếu dữ liệu...',
          validate: 'Đang kiểm tra điều kiện phát hành...',
          issue: 'Đang gửi hoá đơn lên FAST/CQT...',
        }
        this.loadingText = labelByStage[stage] || 'Đang phát hành hoá đơn...'
      },

      // ── Payload builder ───────────────────────────────────────
      buildPayload() {
        return buildEditDraftPayload(this.form)
      },

      // ── Close guard ───────────────────────────────────────────
      onModalHide(bvModalEvt) {
        if (this.isHydrating || this.isSubmitting || this.isIssuing) {
          bvModalEvt.preventDefault()
          return
        }
        if (this.isDirty && bvModalEvt.trigger !== 'force') {
          bvModalEvt.preventDefault()
          this.$bvModal
            .msgBoxConfirm('Bạn có thay đổi chưa lưu. Bạn có chắc muốn đóng?', {
              title: 'Xác nhận đóng',
              okTitle: 'Đóng không lưu',
              okVariant: 'danger',
              cancelTitle: 'Tiếp tục chỉnh sửa',
              centered: true,
              size: 'sm',
            })
            .then((confirmed) => {
              if (confirmed) {
                this.originalFormSnapshot = null
                this.$refs.modal.hide('force')
              }
            })
        }
      },

      // ── Save draft ────────────────────────────────────────────
      async handleSubmit() {
        this.$v.form.$touch()
        if (this.$v.form.$invalid) {
          this.scrollToFirstError()
          return
        }

        this.isSubmitting = true
        this.loadingText = 'Đang lưu thay đổi...'
        try {
          await this.$store.dispatch(EINVOICE_UPDATE_DRAFT, {
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
            payload: this.buildPayload(),
          })
          makeToastSuccess('Cập nhật hoá đơn thành công')
          this.originalFormSnapshot = null
          this.$emit('updated')
          this.$refs.modal.hide('force')
        } catch (err) {
          makeToastFailure(this.getErrorMessage(err))
        } finally {
          this.isSubmitting = false
        }
      },

      // ── Save & Issue (Phase 2.3+2.4) ─────────────────────────
      async handleSaveAndIssue() {
        this.$v.form.$touch()
        if (this.$v.form.$invalid) {
          this.scrollToFirstError()
          return
        }

        const confirmed = await this.$bvModal.msgBoxConfirm(
          'Hoá đơn sẽ được lưu và phát hành đến cơ quan thuế. Thao tác này không thể hoàn tác.',
          {
            title: 'Xác nhận phát hành',
            okTitle: 'Lưu & Phát hành',
            okVariant: 'success',
            cancelTitle: 'Huỷ',
            centered: true,
            size: 'sm',
          },
        )
        if (!confirmed) return

        this.isIssuing = true
        this.loadingText = 'Đang khởi tạo pipeline phát hành...'
        try {
          await runSaveAndIssueFlow({
            dispatch: this.$store.dispatch.bind(this.$store),
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
            payload: this.buildPayload(),
            onStageChange: (stage) => this.applyIssueStage(stage),
          })
          makeToastSuccess('Phát hành hoá đơn thành công')
          this.originalFormSnapshot = null
          this.$emit('updated')
          this.$emit('issued')
          this.$refs.modal.hide('force')
        } catch (err) {
          if (
            err?.flowStage === 'validate' &&
            (err?.isStaleDraft || err?.code === 'DRAFT_RECORD_NOT_FOUND')
          ) {
            await this.handleStaleDraftRecovery()
          }
          makeToastFailure(this.getErrorMessage(err))
        } finally {
          this.isIssuing = false
          this.loadingText = 'Đang lưu thay đổi...'
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-edit-line-product {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.einvoice-edit-line-product__input {
  min-width: 0;
  flex: 1 1 auto;
}

.einvoice-edit-line-product__code {
  margin-top: 4px;
  font-size: 0.72rem;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

